var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobilityScooterHireinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 52,
  r: 6,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 52,
  r: 6,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.5 16 4 30m28-15L47 46m-28 6h24M14 41h24.5m5.5-6h13v6H45.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 11,
  r: 5,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44 49-8-12H21.557a4 4 0 0 1-3.973-3.533l-1.453-12.35A1 1 0 0 1 17.125 20h6.231a1 1 0 0 1 .91.586l4.201 9.242A2 2 0 0 0 30.287 31H35"
}))));
export default SvgMobilityScooterHireinline;